module.exports = "iframe{\r\n    overflow:hidden;\r\n}"